export default __webpack_public_path__ + "static/add-agent-b2bcbb572600c04b1428f376abfd9b4e.png";